import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams, useNavigate } from "react-router-dom";
import GoogleMapMultiple from "../../../../components/GoogleMaps/GoogleMapMultiple";
import CardStyle from "../../../../components/card";
import CheckResponsiveDesktop from "../../../../helper/fnCheckResponsiveDesktop";
import NavTitle from "../../../../components/nav-title";
import { locationValidationRules } from "../func/validation";
import {
  getLocationFormFields,
  getCoordinateFields,
  getSettingFields,
  getRadiusFields,
  getRemarkFields,
  getSettingVFields,
} from "../data/locationFormFields";
import FormField from "../../../../components/input/form-field";
import { filterInput } from "../func/input";
import {
  containerStyle,
  cardStyle,
  contentWrapperStyle,
  titleStyle,
  titleDStyle,
  mainContentStyle,
  leftSectionStyle,
  instructionBoxStyle,
  rightSectionStyle,
  formSectionStyle,
  coordinateWrapperStyle,
  getLocationButtonStyle,
  buttonTextStyle,
  dividerStyle,
  settingsSectionStyle,
  footerStyle,
  buttonGroupStyle,
  cancelButtonStyle,
  saveButtonStyle,
  removeButtonStyle,
  buttonEdit,
} from "../style/locationStyles";
import {
  getLocationDetails,
  createLocationDetails,
  updateLocationDetails,
} from "../../../../services/setting/locations/location-detail";
import SpinnerLoading from "../../../../components/spinner-loading";
import BtnBack from "../../../../components/btn-back";
import { Button } from "react-bootstrap";
import { FaRegPenToSquare } from "react-icons/fa6";
import { TbPinned } from "react-icons/tb";
import ModalRemove from "../../../../components/ModalRemove";
import AlertSuccess from "../../../../alert/AlertSuccess";
import { useTranslation } from "react-i18next";
import { getLocationOrgs } from "../../../../services/setting/locations/location-list";

const LocationDetails = () => {
  const { t } = useTranslation();
  const locationFormFields = getLocationFormFields(t);
  const coordinateFields = getCoordinateFields(t);
  const settingFields = getSettingFields(t);
  const radiusFields = getRadiusFields(t);
  const remarkFields = getRemarkFields(t);
  const settingVFields = getSettingVFields(t);

  const isDesktop = CheckResponsiveDesktop();
  const [searchParams] = useSearchParams();
  const idParams = searchParams.get("id");
  const activeTab = searchParams.get("at");
  const orgId = searchParams.get("o");
  const view = searchParams.get("v");
  const id = parseInt(idParams, 10);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [datagoogleMapsUrl, setGoogleMapsUrl] = useState();
  const [mapPin, setMapPin] = useState(null);
  const [mapRadius, setMapRadius] = useState(0);
  const [isRead, setIsRead] = useState(true);
  // const [isSave, setIsSave] = useState(false);
  const [locations, setLocations] = useState([]);

  const hasId = id !== undefined && id !== null && !Number.isNaN(id);

  const {
    control,
    getValues,
    handleSubmit,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      lat: "",
      long: "",
      radius: "",
      locationNameEn: "",
      locationNameTh: "",
      locationName: "",
      remark: null,
      status: true,
      showInAttendance: true,
    },
  });
  const [showRemove, setshowRemove] = useState({
    isShow: false,
    data: null,
  });

  useEffect(() => {
    if (id) {
      fetchLocationDetails();
    }
  }, [id]);

  const fetchLocationDetails = async () => {
    try {
      setLoading(true);
      // console.log("Fetching location with id:", id);

      const response = await getLocationDetails(id);
      // console.log("Full response:", response);

      // ลองหลายแบบเพื่อหา structure ที่ถูกต้อง
      let data = null;

      if (response?.data?.result) {
        data = response.data.result;
      } else if (response?.result) {
        data = response.result;
      } else if (response?.data?.data?.result) {
        data = response.data.data.result;
      }

      console.log("Extracted data:", data);

      if (data) {
        const formData = {
          lat: data.office_location_lat || "",
          long: data.office_location_lon || "",
          radius: data.office_location_radius || "",
          locationNameEn: data.office_location_name_en || "",
          locationNameTh: data.office_location_name_th || "",
          locationName: data.office_location_name || "",
          remark: data.office_location_remark || null,
          status: data.office_location_status === 1,
          showInAttendance: !data.office_location_hidden,
        };
        // 👉 lat / lon มาจาก result ตรงนี้
        const lat = data.office_location_lat;
        const lon = data.office_location_lon;

        // 👉 logic ถูกแยกออกไปแล้ว
        setGoogleMapsUrl(buildGoogleMapsUrl(lat, lon));

        console.log("Form data to reset:", formData);
        reset(formData);

        if (data.office_location_lat && data.office_location_lon) {
          const pin = {
            lat: Number(data.office_location_lat),
            long: Number(data.office_location_lon),
          };
          const radius = Number(data.office_location_radius || 0);

          console.log("Setting map pin:", pin, "radius:", radius);
          setMapPin(pin);
          setMapRadius(radius);
        }
      } else {
        console.log("No result found in response");
        alert("ไม่พบข้อมูล");
      }
    } catch (error) {
      console.error("Error fetching location details:", error);
      console.error("Error response:", error?.response);
      alert("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    } finally {
      setLoading(false);
    }
  };

  const buildGoogleMapsUrl = (lat, lon) => {
    if (!lat || !lon) return "https://www.google.com/maps";
    return `https://www.google.com/maps?q=${lat},${lon}`;
  };

  const handleGetLocation = async () => {
    const { lat, long, radius } = getValues();
    const parseLocationItem = (item) => {
      const lat = Number(item.office_location_lat);
      const lng = Number(item.office_location_lon);
      const radius = Number(item.office_location_radius);

      if (isNaN(lat) || isNaN(lng)) return null;

      return {
        lat,
        lng,
        radius: isNaN(radius) ? 0 : radius,
        name: item.office_location_name,
        nameEn: item.office_location_name_en,
        nameTh: item.office_location_name_th,
        status: item.office_location_status,
        assignTo: item.assignTo,
      };
    };
    const hasCoords = Boolean(lat && long);
    if (!hasCoords) {
      return;
    }
    setLoading(true);
    try {
      const params = {
        limit: 99,
        ...(hasCoords && {
          current_lat: lat,
          current_lng: long,
          search_radius: 3000,
        }),
      };

      const res = await getLocationOrgs(params);
      const { result, status } = res ?? {};

      if (!status || !Array.isArray(result)) {
        setLocations([]);
        return;
      }

      setLocations(result.map(parseLocationItem).filter(Boolean));
    } catch (err) {
      console.error("Fetch locations error:", err);
      setLocations([]);
    } finally {
      setLoading(false);
    }

    setMapPin({ lat: Number(lat), long: Number(long) });
    setMapRadius(Number(radius));
  };

  const fnCancle = () => {
    fetchLocationDetails(id);
  };
  const goBack = () => {
    navigate(-1);
  };
  const handleCancel = () => {
    setIsRead(!isRead);
    if (isDirty) {
      fnCancle();
    }
  };

  const onSubmit = async (data) => {
    console.log("data", data);

    try {
      setLoading(true);

      const payload = {
        office_location_lat: data.lat,
        office_location_lon: data.long,
        office_location_radius: data.radius,
        office_location_name_en: data.locationNameEn,
        office_location_name_th: data.locationNameTh,
        office_location_name: data.locationName,
        office_location_remark: data.remark ? data.remark : "",
        office_location_status: data.status,
        office_location_hidden: !data.showInAttendance,
      };
      // console.log("Submitting payload:", payload);
      let response;
      if (id) {
        response = await updateLocationDetails({
          ...payload,
          office_location_id: id,
        });
        console.log("Update response:", response);
        // alert("อัพเดทข้อมูลสำเร็จ");
        AlertSuccess(t("hrms_setting_location_success_toast"));
        navigate("/setting/location");
      } else {
        response = await createLocationDetails(payload);
        console.log("Create response:", response);
        AlertSuccess(t("hrms_setting_location_success_toast"));
        navigate("/setting/location");
        // alert("บันทึกข้อมูลสำเร็จ");
      }
    } catch (error) {
      console.error("Error saving location:", error);
      console.error("Error response:", error?.response);
      alert(
        error?.response?.data?.message ||
          "เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง",
      );
    } finally {
      setLoading(false);
    }
  };
  const buttonText = hasId
    ? loading
      ? "Updating..."
      : t("hrms_setting_location_update_bt")
    : loading
      ? "Saving..."
      : t("hrms_setting_location_save_bt");
  const isSaveDisabled = loading || !isValid || !isDirty;
  const renderFooterButtons = () => {
    // ✅ orgs + view mode (ดูอย่างเดียว)
    if (activeTab === "orgs" && view === "1") {
      return (
        <Button
          type="button"
          style={cancelButtonStyle(isDesktop)}
          onClick={goBack}
          disabled={loading}
        >
          {t("hrms_setting_location_close_bt")}
        </Button>
      );
    }
    // กรณีดูอย่างเดียว
    if (hasId && isRead && activeTab !== "orgs") {
      return (
        <Button
          type="button"
          style={cancelButtonStyle(isDesktop)}
          onClick={goBack}
          disabled={loading}
        >
          {t("hrms_setting_location_close_bt")}
        </Button>
      );
    }

    if (loading && id) {
      return (
        <div
          style={{
            ...containerStyle(isDesktop),
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SpinnerLoading />
        </div>
      );
    }

    return (
      <div
        style={{
          ...(activeTab === "orgs"
            ? {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                flexDirection: "row-reverse",
              }
            : {
                ...buttonGroupStyle(isDesktop),
                width: "100%",
              }),
        }}
      >
        <Button
          type="button"
          style={cancelButtonStyle(isDesktop)}
          disabled={loading}
          onClick={
            activeTab === "orgs" || (activeTab !== "orgs" && !hasId && isRead)
              ? goBack
              : handleCancel
          }
          // onClick={activeTab === "orgs" ? goBack : handleCancel}
        >
          {t("hrms_setting_location_cancel_bt")}
        </Button>

        <Button
          // type="submit"
          onClick={
            activeTab === "orgs"
              ? () =>
                  setshowRemove({
                    isShow: true,
                    data: {
                      org_id: orgId,
                      office_location_ids: Array.isArray(id) ? id : [id],
                    },
                  })
              : handleSubmit(onSubmit)
          }
          style={
            activeTab === "orgs"
              ? removeButtonStyle(isDesktop)
              : saveButtonStyle(isDesktop, isSaveDisabled)
          }
          disabled={activeTab !== "orgs" && isSaveDisabled}
        >
          {activeTab === "orgs"
            ? t("hrms_setting_location_remove_bt")
            : buttonText}
        </Button>
      </div>
    );
  };

  return (
    <div>
      {/* <div style={containerStyle(isDesktop)}> */}
      <NavTitle>
        <BtnBack
          // className="text-muted"
          text={
            id
              ? t("hrms_setting_location_topic")
              : t("hrms_setting_location_add_topic")
          }
        />
      </NavTitle>

      <form onSubmit={handleSubmit(onSubmit)} style={{ flex: 1 }}>
        <CardStyle style={cardStyle(isDesktop)}>
          <div style={contentWrapperStyle(isDesktop)}>
            <div className="d-flex gap-3 justify-content-between">
              <div>
                <span style={titleStyle(isDesktop)}>
                  {isRead
                    ? t("hrms_setting_location_detail_header")
                    : t("hrms_setting_location_detail_edit_header")}
                </span>
                {activeTab === "orgs" && (
                  <span style={titleDStyle()}>
                    {t("hrms_setting_location_detail_master_header")}
                  </span>
                )}
              </div>

              {activeTab !== "orgs" && hasId && isRead && (
                <Button
                  size="sm"
                  type="button"
                  className="px-3"
                  style={buttonEdit(isDesktop)}
                  onClick={() => setIsRead(false)}
                >
                  <FaRegPenToSquare
                    style={{ width: "14px" }}
                    className="me-2"
                  />
                  {t("hrms_setting_location_edit_bt")}
                </Button>
              )}
            </div>

            <div style={mainContentStyle(isDesktop)}>
              <div style={leftSectionStyle(isDesktop)}>
                <GoogleMapMultiple
                  maxHeight={isDesktop ? 560 : 250}
                  markerArray={locations}
                  markPin={{
                    lat: mapPin?.lat,
                    long: mapPin?.long,
                    radius: mapPin ? mapRadius : 0,
                  }}
                />
                <div style={instructionBoxStyle(isDesktop)}>
                  {activeTab !== "orgs" && (
                    <>
                      <span style={{ fontWeight: 500 }}>
                        {t("hrms_setting_location_tutorial")}
                      </span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("hrms_setting_location_step_tutorial"),
                        }}
                        style={{ whiteSpace: "pre-line" }}
                      />
                    </>
                  )}
                </div>
              </div>

              <div style={rightSectionStyle(isDesktop)}>
                <div style={formSectionStyle(isDesktop, hasId && isRead)}>
                  {locationFormFields.map((field) => (
                    <FormField
                      disabled={hasId && isRead}
                      key={field.name}
                      {...field}
                      control={control}
                      errors={errors}
                      validationRules={locationValidationRules[field.name]}
                      style={
                        field.name === "radius" && !field.fullWidth
                          ? { width: isDesktop ? "calc(50% - 4px)" : "100%" }
                          : {}
                      }
                      funcfilterInput={filterInput}
                    />
                  ))}

                  <div
                    style={coordinateWrapperStyle(isDesktop, hasId && isRead)}
                  >
                    {coordinateFields.map((field) => (
                      <div key={field.name} style={{ flex: 1 }}>
                        <FormField
                          fontSize12={true}
                          disabled={hasId && isRead}
                          {...field}
                          control={control}
                          errors={errors}
                          validationRules={locationValidationRules[field.name]}
                          funcfilterInput={filterInput}
                        />
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      alignItems:
                        Object.keys(errors).length > 0 ? "center" : "flex-end",
                      gap: 8,
                    }}
                  >
                    <div style={{ width: "50%" }}>
                      <FormField
                        disabled={hasId && isRead}
                        {...radiusFields[0]}
                        control={control}
                        errors={errors}
                        funcfilterInput={filterInput}
                      />
                    </div>

                    <div style={{ width: "50%" }}>
                      <Button
                        type="button"
                        onClick={handleGetLocation}
                        style={{
                          ...getLocationButtonStyle(
                            isDesktop,
                            (hasId && isRead) || loading,
                          ),
                          flexShrink: 0,
                          height: "40px",
                        }}
                        disabled={(hasId && isRead) || loading}
                      >
                        <TbPinned size={18} />
                        <span style={buttonTextStyle}>
                          {t("hrms_setting_location_form_pin_bt")}
                        </span>
                      </Button>
                    </div>
                  </div>

                  <div
                    style={coordinateWrapperStyle(isDesktop, hasId && isRead)}
                  >
                    <div style={{ flex: 1 }}>
                      <FormField
                        disabled={hasId && isRead}
                        {...remarkFields[0]}
                        control={control}
                        errors={errors}
                        validationRules={{}}
                        funcfilterInput={filterInput}
                      />
                    </div>
                  </div>
                </div>

                <hr style={dividerStyle} />
                {activeTab !== "orgs" ? (
                  <>
                    {hasId && isRead ? (
                      <div style={settingsSectionStyle(isDesktop)}>
                        {settingVFields.map((field) => (
                          <FormField
                            key={field.name}
                            {...field}
                            control={control}
                            errors={errors}
                          />
                        ))}
                      </div>
                    ) : (
                      <div style={settingsSectionStyle(isDesktop)}>
                        {settingFields.map((field) => (
                          <FormField
                            disabled={hasId && isRead}
                            key={field.name}
                            {...field}
                            control={control}
                            errors={errors}
                          />
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div style={settingsSectionStyle(isDesktop)}>
                      {settingVFields.map((field) => (
                        <FormField
                          key={field.name}
                          {...field}
                          control={control}
                          errors={errors}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div style={footerStyle(isDesktop)}>
            <div style={buttonGroupStyle(isDesktop)}>
              {renderFooterButtons()}
            </div>
          </div>
        </CardStyle>
      </form>
      {showRemove.isShow && (
        <ModalRemove
          open={showRemove.isShow}
          data={showRemove.data}
          fnDone={() => {
            // setIsAll(false);
            goBack();
          }}
          onCancel={() => {
            setshowRemove({ isShow: false });
          }}
          successText={t("hrms_setting_location_remove_toast")}
        />
      )}
    </div>
  );
};

export default LocationDetails;
